import { render, staticRenderFns } from "./Attendant.vue?vue&type=template&id=9d50cfd4&"
import script from "./Attendant.vue?vue&type=script&lang=ts&"
export * from "./Attendant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports